import { DialogTitle, Grid, IconButton } from "@mui/material";
import i18n from 'i18next';
import defaultCloseIcon from '../../images/customCloseIcon.svg';
import { withStyles, WithStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
//import { FC } from 'react'
const styles = ({ breakpoints, spacing }: Theme) => ({
    dialog: {
        padding: '25px 25px 10px 25px'
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    title: {
        color: '#7B8189',
        fontSize: '0.8rem',
        'text-transform': 'uppercase'
    },
    button: {
        padding: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#4f9b44',
        transform: 'scale(1.35)'
    },
    image: {
        width: '15px',
        margin: '5px'
    },
});
interface TitleWithCloseButton extends WithStyles<typeof styles> {
    t: i18n.TFunction;
    title: string;
    closeAction: any;
    hideCloseIcon?: boolean;
    customCloseIcon?: any;
    onClose?: () => void;
}
const TitleWithCloseButton = ({ title, t, closeAction, hideCloseIcon, classes, customCloseIcon, onClose }: TitleWithCloseButton) => (<DialogTitle id='title-with-close' className={classes.dialog}>
    <Grid container className={classes.container}>
      <Grid item className={classes.title}>
        {title}
      </Grid>
      <Grid item>
        {!hideCloseIcon && (<IconButton aria-label={t('general.close')} onClick={() => {
            if (onClose) {
                onClose();
            }
            closeAction();
        }} className={classes.button}>
            <img className={classes.image} src={customCloseIcon || defaultCloseIcon}/>
          </IconButton>)}
      </Grid>
    </Grid>
  </DialogTitle>);
export default withStyles(styles as any)(TitleWithCloseButton) as any;
